import type { CSSProperties, ReactNode } from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { useBanner } from '../../bannerProvider';
import { BaseBlock } from '../_block';

export type SpacingBlockProps = {
  className?: string;
  children?: ReactNode;
  spacing: number;
  mobileSpacing: number;
  applyMobileSettings: boolean;
  style?: CSSProperties;
};

export const SpacingBlock = forwardRef<HTMLDivElement, SpacingBlockProps>(
  (
    { className, children, spacing, mobileSpacing, applyMobileSettings, style },
    forwardingRef
  ) => {
    const { contentDirection } = useBanner();

    const isColumn = contentDirection === 'column';
    const marginNameStart = isColumn ? 'top' : 'left';

    const currentSpacing = applyMobileSettings ? mobileSpacing : spacing;

    const columnStyle = {
      height: `${currentSpacing}px`
    };

    const rowStyle = {
      width: `${currentSpacing}px`
    };

    const selectDirectionSize = isColumn ? columnStyle : rowStyle;

    return (
      <Base
        className={className}
        _marginNameStart={marginNameStart}
        ref={forwardingRef}
        style={{
          ...selectDirectionSize,
          ...style
        }}
      >
        {children}
      </Base>
    );
  }
);

const Base = styled.div<{
  _marginNameStart: 'top' | 'left';
}>`
  & + ${BaseBlock} {
    ${({ _marginNameStart }) => `margin-${_marginNameStart}: 0;`}
  }
`;
